"use client";
import { ErrorFeedback } from "@/components/Error";
import { useTranslations } from "next-intl";
import { Container } from "./styles";

export const ErrorScreen = () => {
  const t = useTranslations("errors");
  return (
    <Container>
      <ErrorFeedback
        message={t("error.title")}
        details={t("error.description")}
        buttonText={t("error.action")}
        handleButtonClick={() => window.location.reload()}
        contactSupport={false}
      />
    </Container>
  );
};
